// eslint-disable-next-line import/prefer-default-export
export const countries = ['India'];

export const cities = {
  'Andaman and Nicobar Islands': ['Port Blair'],
  'Andhra Pradesh': [
    'Adoni',
    'Amalapuram',
    'Anakapalle',
    'Anantapur',
    'Bapatla',
    'Bheemunipatnam',
    'Bhimavaram',
    'Bobbili',
    'Chilakaluripet',
    'Chirala',
    'Chittoor',
    'Dharmavaram',
    'Eluru',
    'Gooty',
    'Gudivada',
    'Gudur',
    'Guntakal',
    'Guntur',
    'Hindupur',
    'Jaggaiahpet',
    'Jammalamadugu',
    'Kadapa',
    'Kadiri',
    'Kakinada',
    'Kandukur',
    'Kavali',
    'Kovvur',
    'Kurnool',
    'Macherla',
    'Machilipatnam',
    'Madanapalle',
    'Mandapeta',
    'Markapur',
    'Nagari',
    'Naidupet',
    'Nandyal',
    'Narasapuram',
    'Narasaraopet',
    'Narsipatnam',
    'Nellore',
    'Nidadavole',
    'Nuzvid',
    'Ongole',
    'Palacole',
    'Palasa Kasibugga',
    'Parvathipuram',
    'Pedana',
    'Peddapuram',
    'Pithapuram',
    'Ponnur',
    'Proddatur',
    'Punganur',
    'Puttur',
    'Rajahmundry',
    'Rajam',
    'Rajampet',
    'Ramachandrapuram',
    'Rayachoti',
    'Rayadurg',
    'Renigunta',
    'Repalle',
    'Salur',
    'Samalkot',
    'Sattenapalle',
    'Srikakulam',
    'Srikalahasti',
    'Srisailam Project (Right Flank Colony) Township',
    'Sullurpeta',
    'Tadepalligudem',
    'Tadpatri',
    'Tanuku',
    'Tenali',
    'Tirupati',
    'Tiruvuru',
    'Tuni',
    'Uravakonda',
    'Venkatagiri',
    'Vijayawada',
    'Vinukonda',
    'Visakhapatnam',
    'Vizianagaram',
    'Yemmiganur',
    'Yerraguntla'
  ],
  'Arunachal Pradesh': ['Naharlagun', 'Pasighat'],
  Assam: [
    'Barpeta',
    'Bongaigaon City',
    'Dhubri',
    'Dibrugarh',
    'Diphu',
    'Goalpara',
    'Guwahati',
    'Jorhat',
    'Karimganj',
    'Lanka',
    'Lumding',
    'Mangaldoi',
    'Mankachar',
    'Margherita',
    'Mariani',
    'Marigaon',
    'Nagaon',
    'Nalbari',
    'North Lakhimpur',
    'Rangia',
    'Sibsagar',
    'Silapathar',
    'Silchar',
    'Tezpur',
    'Tinsukia'
  ],
  Bihar: [
    'Araria',
    'Arrah',
    'Arwal',
    'Asarganj',
    'Aurangabad',
    'Bagaha',
    'Barh',
    'Begusarai',
    'Bettiah',
    'BhabUrban Agglomeration',
    'Bhagalpur',
    'Buxar',
    'Chhapra',
    'Darbhanga',
    'Dehri-on-Sone',
    'Dumraon',
    'Forbesganj',
    'Gaya',
    'Gopalganj',
    'Hajipur',
    'Jamalpur',
    'Jamui',
    'Jehanabad',
    'Katihar',
    'Kishanganj',
    'Lakhisarai',
    'Lalganj',
    'Madhepura',
    'Madhubani',
    'Maharajganj',
    'Mahnar Bazar',
    'Makhdumpur',
    'Maner',
    'Manihari',
    'Marhaura',
    'Masaurhi',
    'Mirganj',
    'Mokameh',
    'Motihari',
    'Motipur',
    'Munger',
    'Murliganj',
    'Muzaffarpur',
    'Narkatiaganj',
    'Naugachhia',
    'Nawada',
    'Nokha',
    'Patna',
    'Piro',
    'Purnia',
    'Rafiganj',
    'Rajgir',
    'Ramnagar',
    'Raxaul Bazar',
    'Revelganj',
    'Rosera',
    'Saharsa',
    'Samastipur',
    'Sasaram',
    'Sheikhpura',
    'Sheohar',
    'Sherghati',
    'Silao',
    'Sitamarhi',
    'Siwan',
    'Sonepur',
    'Sugauli',
    'Sultanganj',
    'Supaul',
    'Warisaliganj'
  ],
  Chandigarh: ['Chandigarh'],
  Chhattisgarh: [
    'Ambikapur',
    'Bhatapara',
    'Bhilai Nagar',
    'Bilaspur',
    'Chirmiri',
    'Dalli-Rajhara',
    'Dhamtari',
    'Durg',
    'Jagdalpur',
    'Korba',
    'Mahasamund',
    'Manendragarh',
    'Mungeli',
    'Naila Janjgir',
    'Raigarh',
    'Raipur',
    'Rajnandgaon',
    'Sakti',
    'Tilda Newra'
  ],
  'Dadra and Nagar Haveli': ['Silvassa'],
  Delhi: ['Delhi', 'New Delhi'],
  Goa: ['Mapusa', 'Margao', 'Marmagao', 'Panaji'],
  Gujarat: [
    'Adalaj',
    'Ahmedabad',
    'Amreli',
    'Anand',
    'Anjar',
    'Ankleshwar',
    'Bharuch',
    'Bhavnagar',
    'Bhuj',
    'Chhapra',
    'Deesa',
    'Dhoraji',
    'Gandhinagar',
    'Godhra',
    'Jamnagar',
    'Kadi',
    'Kapadvanj',
    'Keshod',
    'Khambhat',
    'Lathi',
    'Limbdi',
    'Lunawada',
    'Mahemdabad',
    'Mahesana',
    'Mahuva',
    'Manavadar',
    'Mandvi',
    'Mangrol',
    'Mansa',
    'Modasa',
    'Morvi',
    'Nadiad',
    'Navsari',
    'Padra',
    'Palanpur',
    'Palitana',
    'Pardi',
    'Patan',
    'Petlad',
    'Porbandar',
    'Radhanpur',
    'Rajkot',
    'Rajpipla',
    'Rajula',
    'Ranavav',
    'Rapar',
    'Salaya',
    'Sanand',
    'Savarkundla',
    'Sidhpur',
    'Sihor',
    'Songadh',
    'Surat',
    'Talaja',
    'Thangadh',
    'Tharad',
    'Umbergaon',
    'Umreth',
    'Una',
    'Unjha',
    'Upleta',
    'Vadnagar',
    'Vadodara',
    'Valsad',
    'Vapi',
    'Vapi',
    'Veraval',
    'Vijapur',
    'Viramgam',
    'Visnagar',
    'Vyara',
    'Wadhwan',
    'Wankaner'
  ],
  Haryana: [
    'Bahadurgarh',
    'Bhiwani',
    'Charkhi Dadri',
    'Faridabad',
    'Fatehabad',
    'Gohana',
    'Gurgaon',
    'Hansi',
    'Hisar',
    'Jind',
    'Kaithal',
    'Karnal',
    'Ladwa',
    'Mahendragarh',
    'Mandi Dabwali',
    'Narnaul',
    'Narwana',
    'Palwal',
    'Panchkula',
    'Panipat',
    'Pehowa',
    'Pinjore',
    'Rania',
    'Ratia',
    'Rewari',
    'Rohtak',
    'Safidon',
    'Samalkha',
    'Sarsod',
    'Shahbad',
    'Sirsa',
    'Sohna',
    'Sonipat',
    'Taraori',
    'Thanesar',
    'Tohana',
    'Yamunanagar'
  ],
  'Himachal Pradesh': [
    'Kullu',
    'Manali',
    'Mandi',
    'Nahan',
    'Palampur',
    'Shimla',
    'Solan',
    'Sundarnagar'
  ],
  'Jammu and Kashmir': [
    'Anantnag',
    'Baramula',
    'Jammu',
    'KathUrban Agglomeration',
    'Punch',
    'Rajauri',
    'Sopore',
    'Srinagar',
    'Udhampur'
  ],
  Jharkhand: [
    'Adityapur',
    'Bokaro Steel City',
    'Chaibasa',
    'Chatra',
    'Chirkunda',
    'Deoghar',
    'Dhanbad',
    'Dumka',
    'Giridih',
    'Gumia',
    'Hazaribag',
    'Jamshedpur',
    'Jhumri Tilaiya',
    'Lohardaga',
    'Madhupur',
    'Medininagar (Daltonganj)',
    'Mihijam',
    'Musabani',
    'Pakaur',
    'Patratu',
    'Phusro',
    'Ramgarh',
    'Ranchi',
    'Sahibganj',
    'Saunda',
    'Simdega',
    'Tenu dam-cum-Kathhara'
  ],
  Karnataka: [
    'Adyar',
    'Afzalpur',
    'Arsikere',
    'Athni',
    'Ballari',
    'Belagavi',
    'Bengaluru',
    'Chikkamagaluru',
    'Davanagere',
    'Gokak',
    'Hubli-Dharwad',
    'Karwar',
    'Kolar',
    'Lakshmeshwar',
    'Lingsugur',
    'Maddur',
    'Madhugiri',
    'Madikeri',
    'Magadi',
    'Mahalingapura',
    'Malavalli',
    'Malur',
    'Mandya',
    'Mangaluru',
    'Manvi',
    'Mudabidri',
    'Mudalagi',
    'Muddebihal',
    'Mudhol',
    'Mulbagal',
    'Mundargi',
    'Mysore',
    'Nanjangud',
    'Nargund',
    'Navalgund',
    'Nelamangala',
    'Pavagada',
    'Piriyapatna',
    'Puttur',
    'Raayachuru',
    'Rabkavi Banhatti',
    'Ramanagaram',
    'Ramdurg',
    'Ranebennuru',
    'Ranibennur',
    'Robertson Pet',
    'Ron',
    'Sadalagi',
    'Sagara',
    'Sakaleshapura',
    'Sanduru',
    'Sankeshwara',
    'Saundatti-Yellamma',
    'Savanur',
    'Sedam',
    'Shahabad',
    'Shahpur',
    'Shiggaon',
    'Shikaripur',
    'Shivamogga',
    'Shrirangapattana',
    'Sidlaghatta',
    'Sindagi',
    'Sindhagi',
    'Sindhnur',
    'Sira',
    'Sirsi',
    'Siruguppa',
    'Srinivaspur',
    'Surapura',
    'Talikota',
    'Tarikere',
    'Tekkalakote',
    'Terdal',
    'Tiptur',
    'Tumkur',
    'Udupi',
    'Vijayapura',
    'Wadi',
    'Yadgir'
  ],
  Kerala: [
    'Adoor',
    'Alappuzha',
    'Attingal',
    'Chalakudy',
    'Changanassery',
    'Cherthala',
    'Chittur-Thathamangalam',
    'Guruvayoor',
    'Kanhangad',
    'Kannur',
    'Kasaragod',
    'Kayamkulam',
    'Kochi',
    'Kodungallur',
    'Kollam',
    'Kottayam',
    'Koyilandy',
    'Kozhikode',
    'Kunnamkulam',
    'Malappuram',
    'Mattannur',
    'Mavelikkara',
    'Mavoor',
    'Muvattupuzha',
    'Nedumangad',
    'Neyyattinkara',
    'Nilambur',
    'Ottappalam',
    'Palai',
    'Palakkad',
    'Panamattom',
    'Panniyannur',
    'Pappinisseri',
    'Paravoor',
    'Pathanamthitta',
    'Peringathur',
    'Perinthalmanna',
    'Perumbavoor',
    'Ponnani',
    'Punalur',
    'Puthuppally',
    'Shoranur',
    'Taliparamba',
    'Thiruvalla',
    'Thiruvananthapuram',
    'Thodupuzha',
    'Thrissur',
    'Tirur',
    'Vaikom',
    'Varkala',
    'Vatakara'
  ],
  'Madhya Pradesh': [
    'Alirajpur',
    'Ashok Nagar',
    'Balaghat',
    'Bhopal',
    'Ganjbasoda',
    'Gwalior',
    'Indore',
    'Itarsi',
    'Jabalpur',
    'Lahar',
    'Maharajpur',
    'Mahidpur',
    'Maihar',
    'Malaj Khand',
    'Manasa',
    'Manawar',
    'Mandideep',
    'Mandla',
    'Mandsaur',
    'Mauganj',
    'Mhow Cantonment',
    'Mhowgaon',
    'Morena',
    'Multai',
    'Mundi',
    'Murwara (Katni)',
    'Nagda',
    'Nainpur',
    'Narsinghgarh',
    'Narsinghgarh',
    'Neemuch',
    'Nepanagar',
    'Niwari',
    'Nowgong',
    'Nowrozabad (Khodargama)',
    'Pachore',
    'Pali',
    'Panagar',
    'Pandhurna',
    'Panna',
    'Pasan',
    'Pipariya',
    'Pithampur',
    'Porsa',
    'Prithvipur',
    'Raghogarh-Vijaypur',
    'Rahatgarh',
    'Raisen',
    'Rajgarh',
    'Ratlam',
    'Rau',
    'Rehli',
    'Rewa',
    'Sabalgarh',
    'Sagar',
    'Sanawad',
    'Sarangpur',
    'Sarni',
    'Satna',
    'Sausar',
    'Sehore',
    'Sendhwa',
    'Seoni',
    'Seoni-Malwa',
    'Shahdol',
    'Shajapur',
    'Shamgarh',
    'Sheopur',
    'Shivpuri',
    'Shujalpur',
    'Sidhi',
    'Sihora',
    'Singrauli',
    'Sironj',
    'Sohagpur',
    'Tarana',
    'Tikamgarh',
    'Ujjain',
    'Umaria',
    'Vidisha',
    'Vijaypur',
    'Wara Seoni'
  ],
  Maharashtra: [
    'Achalpur',
    'Ahmednagar',
    'Akola',
    'Akot',
    'Amalner',
    'Ambejogai',
    'Amravati',
    'Anjangaon',
    'Arvi',
    'Aurangabad',
    'Bhiwandi',
    'Dhule',
    'Ichalkaranji',
    'Kalyan-Dombivali',
    'Karjat',
    'Latur',
    'Loha',
    'Lonar',
    'Lonavla',
    'Mahad',
    'Malegaon',
    'Malkapur',
    'Mangalvedhe',
    'Mangrulpir',
    'Manjlegaon',
    'Manmad',
    'Manwath',
    'Mehkar',
    'Mhaswad',
    'Mira-Bhayandar',
    'Morshi',
    'Mukhed',
    'Mul',
    'Mumbai',
    'Murtijapur',
    'Nagpur',
    'Nanded-Waghala',
    'Nandgaon',
    'Nandura',
    'Nandurbar',
    'Narkhed',
    'Nashik',
    'Nawapur',
    'Nilanga',
    'Osmanabad',
    'Ozar',
    'Pachora',
    'Paithan',
    'Palghar',
    'Pandharkaoda',
    'Pandharpur',
    'Panvel',
    'Parbhani',
    'Parli',
    'Partur',
    'Pathardi',
    'Pathri',
    'Patur',
    'Pauni',
    'Pen',
    'Phaltan',
    'Pulgaon',
    'Pune',
    'Purna',
    'Pusad',
    'Rahuri',
    'Rajura',
    'Ramtek',
    'Ratnagiri',
    'Raver',
    'Risod',
    'Sailu',
    'Sangamner',
    'Sangli',
    'Sangole',
    'Sasvad',
    'Satana',
    'Satara',
    'Savner',
    'Sawantwadi',
    'Shahade',
    'Shegaon',
    'Shendurjana',
    'Shirdi',
    'Shirpur-Warwade',
    'Shirur',
    'Shrigonda',
    'Shrirampur',
    'Sillod',
    'Sinnar',
    'Solapur',
    'Soyagaon',
    'Talegaon Dabhade',
    'Talode',
    'Tasgaon',
    'Thane',
    'Tirora',
    'Tuljapur',
    'Tumsar',
    'Uchgaon',
    'Udgir',
    'Umarga',
    'Umarkhed',
    'Umred',
    'Uran',
    'Uran Islampur',
    'Vadgaon Kasba',
    'Vaijapur',
    'Vasai-Virar',
    'Vita',
    'Wadgaon Road',
    'Wai',
    'Wani',
    'Wardha',
    'Warora',
    'Warud',
    'Washim',
    'Yavatmal',
    'Yawal',
    'Yevla'
  ],
  Manipur: ['Imphal', 'Lilong', 'Mayang Imphal', 'Thoubal'],
  Meghalaya: ['Nongstoin', 'Shillong', 'Tura'],
  Mizoram: ['Aizawl', 'Lunglei', 'Saiha'],
  Nagaland: [
    'Dimapur',
    'Kohima',
    'Mokokchung',
    'Tuensang',
    'Wokha',
    'Zunheboto'
  ],
  Odisha: [
    'Balangir',
    'Baleshwar Town',
    'Barbil',
    'Bargarh',
    'Baripada Town',
    'Bhadrak',
    'Bhawanipatna',
    'Bhubaneswar',
    'Brahmapur',
    'Byasanagar',
    'Cuttack',
    'Dhenkanal',
    'Jatani',
    'Jharsuguda',
    'Kendrapara',
    'Kendujhar',
    'Malkangiri',
    'Nabarangapur',
    'Paradip',
    'Parlakhemundi',
    'Pattamundai',
    'Phulabani',
    'Puri',
    'Rairangpur',
    'Rajagangapur',
    'Raurkela',
    'Rayagada',
    'Sambalpur',
    'Soro',
    'Sunabeda',
    'Sundargarh',
    'Talcher',
    'Tarbha',
    'Titlagarh'
  ],
  Puducherry: ['Karaikal', 'Mahe', 'Pondicherry', 'Yanam'],
  Punjab: [
    'Amritsar',
    'Barnala',
    'Batala',
    'Bathinda',
    'Dhuri',
    'Faridkot',
    'Fazilka',
    'Firozpur',
    'Firozpur Cantt.',
    'Gobindgarh',
    'Gurdaspur',
    'Hoshiarpur',
    'Jagraon',
    'Jalandhar',
    'Jalandhar Cantt.',
    'Kapurthala',
    'Khanna',
    'Kharar',
    'Kot Kapura',
    'Longowal',
    'Ludhiana',
    'Malerkotla',
    'Malout',
    'Mansa',
    'Moga',
    'Mohali',
    'Morinda, India',
    'Mukerian',
    'Muktsar',
    'Nabha',
    'Nakodar',
    'Nangal',
    'Nawanshahr',
    'Pathankot',
    'Patiala',
    'Patti',
    'Pattran',
    'Phagwara',
    'Phillaur',
    'Qadian',
    'Raikot',
    'Rajpura',
    'Rampura Phul',
    'Rupnagar',
    'Samana',
    'Sangrur',
    'Sirhind Fatehgarh Sahib',
    'Sujanpur',
    'Sunam',
    'Talwara',
    'Tarn Taran',
    'Urmar Tanda',
    'Zira',
    'Zirakpur'
  ],
  Rajasthan: [
    'Ajmer',
    'Alwar',
    'Barmer',
    'Bharatpur',
    'Bhilwara',
    'Bikaner',
    'Jaipur',
    'Jodhpur',
    'Lachhmangarh',
    'Ladnu',
    'Lakheri',
    'Lalsot',
    'Losal',
    'Makrana',
    'Malpura',
    'Mandalgarh',
    'Mandawa',
    'Mangrol',
    'Merta City',
    'Mount Abu',
    'Nadbai',
    'Nagar',
    'Nagaur',
    'Nasirabad',
    'Nathdwara',
    'Neem-Ka-Thana',
    'Nimbahera',
    'Nohar',
    'Nokha',
    'Pali',
    'Phalodi',
    'Phulera',
    'Pilani',
    'Pilibanga',
    'Pindwara',
    'Pipar City',
    'Prantij',
    'Pratapgarh',
    'Raisinghnagar',
    'Rajakhera',
    'Rajaldesar',
    'Rajgarh (Alwar)',
    'Rajgarh (Churu)',
    'Rajsamand',
    'Ramganj Mandi',
    'Ramngarh',
    'Ratangarh',
    'Rawatbhata',
    'Rawatsar',
    'Reengus',
    'Sadri',
    'Sadulpur',
    'Sadulshahar',
    'Sagwara',
    'Sambhar',
    'Sanchore',
    'Sangaria',
    'Sardarshahar',
    'Sawai Madhopur',
    'Shahpura',
    'Shahpura',
    'Sheoganj',
    'Sikar',
    'Sirohi',
    'Sojat',
    'Sri Madhopur',
    'Sujangarh',
    'Sumerpur',
    'Suratgarh',
    'Takhatgarh',
    'Taranagar',
    'Todabhim',
    'Todaraisingh',
    'Tonk',
    'Udaipur',
    'Udaipurwati',
    'Vijainagar, Ajmer'
  ],
  'Tamil Nadu': [
    'Chennai',
    'Coimbatore',
    'Madurai',
    'Tiruchirappalli',
    'Salem',
    'Tirunelveli',
    'Tiruppur',
    'Ranipet',
    'Nagercoil',
    'Thanjavur',
    'Vellore',
    'Kancheepuram',
    'Erode',
    'Tiruvannamalai',
    'Pollachi',
    'Rajapalayam',
    'Sivakasi',
    'Pudukkottai',
    'Neyveli (TS)',
    'Nagapattinam',
    'Viluppuram',
    'Tiruchengode',
    'Vaniyambadi',
    'Theni Allinagaram',
    'Udhagamandalam',
    'Aruppukkottai',
    'Paramakudi',
    'Arakkonam',
    'Virudhachalam',
    'Srivilliputhur',
    'Tindivanam',
    'Virudhunagar',
    'Karur',
    'Valparai',
    'Sankarankovil',
    'Tenkasi',
    'Palani',
    'Pattukkottai',
    'Tirupathur',
    'Ramanathapuram',
    'Udumalaipettai',
    'Gobichettipalayam',
    'Thiruvarur',
    'Thiruvallur',
    'Panruti',
    'Namakkal',
    'Thirumangalam',
    'Vikramasingapuram',
    'Nellikuppam',
    'Rasipuram',
    'Tiruttani',
    'Nandivaram-Guduvancheri',
    'Periyakulam',
    'Pernampattu',
    'Vellakoil',
    'Sivaganga',
    'Vadalur',
    'Rameshwaram',
    'Tiruvethipuram',
    'Perambalur',
    'Usilampatti',
    'Vedaranyam',
    'Sathyamangalam',
    'Puliyankudi',
    'Nanjikottai',
    'Thuraiyur',
    'Sirkali',
    'Tiruchendur',
    'Periyasemur',
    'Sattur',
    'Vandavasi',
    'Tharamangalam',
    'Tirukkoyilur',
    'Oddanchatram',
    'Palladam',
    'Vadakkuvalliyur',
    'Tirukalukundram',
    'Uthamapalayam',
    'Surandai',
    'Sankari',
    'Shenkottai',
    'Vadipatti',
    'Sholingur',
    'Tirupathur',
    'Manachanallur',
    'Viswanatham',
    'Polur',
    'Panagudi',
    'Uthiramerur',
    'Thiruthuraipoondi',
    'Pallapatti',
    'Ponneri',
    'Lalgudi',
    'Natham',
    'Unnamalaikadai',
    'P.N.Patti',
    'Tharangambadi',
    'Tittakudi',
    'Pacode',
    'O Valley',
    'Suriyampalayam',
    'Sholavandan',
    'Thammampatti',
    'Namagiripettai',
    'Peravurani',
    'Parangipettai',
    'Pudupattinam',
    'Pallikonda',
    'Sivagiri',
    'Punjaipugalur',
    'Padmanabhapuram',
    'Thirupuvanam'
  ],
  Telangana: [
    'Adilabad',
    'Bellampalle',
    'Bhadrachalam',
    'Bhainsa',
    'Bhongir',
    'Bodhan',
    'Farooqnagar',
    'Gadwal',
    'Hyderabad',
    'Jagtial',
    'Jangaon',
    'Kagaznagar',
    'Kamareddy',
    'Karimnagar',
    'Khammam',
    'Koratla',
    'Kothagudem',
    'Kyathampalle',
    'Mahbubnagar',
    'Mancherial',
    'Mandamarri',
    'Manuguru',
    'Medak',
    'Miryalaguda',
    'Nagarkurnool',
    'Narayanpet',
    'Nirmal',
    'Nizamabad',
    'Palwancha',
    'Ramagundam',
    'Sadasivpet',
    'Sangareddy',
    'Siddipet',
    'Sircilla',
    'Suryapet',
    'Tandur',
    'Vikarabad',
    'Wanaparthy',
    'Warangal',
    'Yellandu'
  ],
  Tripura: [
    'Agartala',
    'Belonia',
    'Dharmanagar',
    'Kailasahar',
    'Khowai',
    'Pratapgarh',
    'Udaipur'
  ],
  'Uttar Pradesh': [
    'Lucknow',
    'Kanpur',
    'Firozabad',
    'Agra',
    'Meerut',
    'Varanasi',
    'Allahabad',
    'Amroha',
    'Moradabad',
    'Aligarh',
    'Saharanpur',
    'Noida',
    'Loni',
    'Jhansi',
    'Shahjahanpur',
    'Rampur',
    'Modinagar',
    'Hapur',
    'Etawah',
    'Sambhal',
    'Orai',
    'Bahraich',
    'Unnao',
    'Rae Bareli',
    'Lakhimpur',
    'Sitapur',
    'Lalitpur',
    'Pilibhit',
    'Chandausi',
    'Hardoi ',
    'Azamgarh',
    'Khair',
    'Sultanpur',
    'Tanda',
    'Nagina',
    'Shamli',
    'Najibabad',
    'Shikohabad',
    'Sikandrabad',
    'Shahabad, Hardoi',
    'Pilkhuwa',
    'Renukoot',
    'Vrindavan',
    'Ujhani',
    'Laharpur',
    'Tilhar',
    'Sahaswan',
    'Rath',
    'Sherkot',
    'Kalpi',
    'Tundla',
    'Sandila',
    'Nanpara',
    'Sardhana',
    'Nehtaur',
    'Seohara',
    'Padrauna',
    'Mathura',
    'Thakurdwara',
    'Nawabganj',
    'Siana',
    'Noorpur',
    'Sikandra Rao',
    'Puranpur',
    'Rudauli',
    'Thana Bhawan',
    'Palia Kalan',
    'Zaidpur',
    'Nautanwa',
    'Zamania',
    'Shikarpur, Bulandshahr',
    'Naugawan Sadat',
    'Fatehpur Sikri',
    'Shahabad, Rampur',
    'Robertsganj',
    'Utraula',
    'Sadabad',
    'Rasra',
    'Lar',
    'Lal Gopalganj Nindaura',
    'Sirsaganj',
    'Pihani',
    'Shamsabad, Agra',
    'Rudrapur',
    'Soron',
    'SUrban Agglomerationr',
    'Samdhan',
    'Sahjanwa',
    'Rampur Maniharan',
    'Sumerpur',
    'Shahganj',
    'Tulsipur',
    'Tirwaganj',
    'PurqUrban Agglomerationzi',
    'Shamsabad, Farrukhabad',
    'Warhapur',
    'Powayan',
    'Sandi',
    'Achhnera',
    'Naraura',
    'Nakur',
    'Sahaspur',
    'Safipur',
    'Reoti',
    'Sikanderpur',
    'Saidpur',
    'Sirsi',
    'Purwa',
    'Parasi',
    'Lalganj',
    'Phulpur',
    'Shishgarh',
    'Sahawar',
    'Samthar',
    'Pukhrayan',
    'Obra',
    'Niwai',
    'Mirzapur'
  ],
  Uttarakhand: [
    'Bageshwar',
    'Dehradun',
    'Haldwani-cum-Kathgodam',
    'Hardwar',
    'Kashipur',
    'Manglaur',
    'Mussoorie',
    'Nagla',
    'Nainital',
    'Pauri',
    'Pithoragarh',
    'Ramnagar',
    'Rishikesh',
    'Roorkee',
    'Rudrapur',
    'Sitarganj',
    'Srinagar',
    'Tehri'
  ],
  'West Bengal': [
    'Adra',
    'AlipurdUrban Agglomerationr',
    'Arambagh',
    'Asansol',
    'Baharampur',
    'Balurghat',
    'Bankura',
    'Darjiling',
    'English Bazar',
    'Gangarampur',
    'Habra',
    'Hugli-Chinsurah',
    'Jalpaiguri',
    'Jhargram',
    'Kalimpong',
    'Kharagpur',
    'Kolkata',
    'Mainaguri',
    'Malda',
    'Mathabhanga',
    'Medinipur',
    'Memari',
    'Monoharpur',
    'Murshidabad',
    'Nabadwip',
    'Naihati',
    'Panchla',
    'PandUrban Agglomeration',
    'Paschim Punropara',
    'Purulia',
    'Raghunathganj',
    'Raghunathpur',
    'Raiganj',
    'Rampurhat',
    'Ranaghat',
    'Sainthia',
    'Santipur',
    'Siliguri',
    'Sonamukhi',
    'Srirampore',
    'Suri',
    'Taki',
    'Tamluk',
    'Tarakeswar'
  ]
};
